import _ from 'lodash';
import moment from 'moment';
import user from 'user/logic/user';
import privileges from 'privilege-templates/logic/privilege-templates';

import { applyMenu, applyTokens, setGtmsTime } from 'auth/actions/session.actions';
import sessionModule from './session';

const LOGOUT_CODE = 'USER_LOGOUT';

const CONTEXT = 'auth';
const FORGOT_PASSOWRD_CONTEXT = 'forgotPassword';
const FORGOT_USERNAME_CONTEXT = 'forgotUsername';

function initializeModel(deps, model) {
  return _.merge(model, {
    credentials: {},
    forgotPassword: {},
  });
}

function getServerTime(deps, model) {
  if (!_.get(model, 'session.loggedIn')) {
    return Promise.resolve(model);
  }
  return deps.restSrv
    .list(CONTEXT, model.session.rest.server.time.url, null, null, 'server.time')
    .then((result) => {
      const gtmsTime = _.get(result, 'gtmsTime');
      const gtmsTimeUnix = moment.utc(gtmsTime).unix();
      deps.config.serverTime = gtmsTimeUnix;
      deps.$ngRedux.dispatch(setGtmsTime(gtmsTimeUnix));
      return Promise.resolve(model);
    })
    .catch(() => {
      deps.config.serverTime = moment().unix();
      return Promise.resolve(model);
    });
}

async function loginByRest(...args) {
  let [
    deps,
    model,
    credentials,
    restUrl,
    acceptTerms,
    registrationForm = false,
    loginAs = false,
    tokens,
    impersonatingDisplayName,
    adminId,
  ] = args;
  const state = deps.$ngRedux.getState();
  const { session } = state;
  const { restSrv } = deps;
  if (!tokens) {
    let queryParams;
    let urlParams;
    if (loginAs) {
      queryParams = {
        userId: credentials.userId,
        token: session.tokens.refresh.code,
      };
    } else {
      queryParams = {
        resourceOwnerCredentials: {
          username: credentials.email,
          password: credentials.password,
        },
        clientId: session.oAuthClientId,
        siteId: session.siteId,
      };
      urlParams = {
        acceptTerms,
        registrationForm,
      };
    }
    tokens = await restSrv.create(CONTEXT, restUrl, queryParams, urlParams);
  }

  const [jwtToken] = tokens;
  deps.$ngRedux.dispatch(applyTokens(tokens));
  if (_.get(jwtToken, 'tokenParams.passwordExpired') === 'true') return Promise.resolve(model);

  return user
    .loadUserByLogin(restSrv, credentials.email, model)
    .then(user.loadLotteryLearningLink.bind(null, restSrv))
    .then((params) => sessionModule.applySessionData(_.merge(params, { config: deps.config, loginAs, adminId, impersonatingDisplayName })))
    .then(privileges.loadUserSessionPrivileges.bind(null, deps))
    .then((newModel) => deps.$ngRedux.dispatch(applyMenu(newModel)))
    .then((newModel) => {
      if (session.locale !== newModel.session.locale) sessionModule.changeLocale(deps, newModel, newModel.session.locale);
      return newModel;
    })
    .then((newModel) => {
      newModel.credentials = {};
      return newModel;
    })
    .then((newModel) => {
      deps.initNgServices(newModel);
      return newModel;
    })
    .then((newModel) => getServerTime(deps, newModel));
}

function login(...args) {
  const [deps, model, credentials, acceptTerms, registrationForm = false, tokens] = args;
  const restUrl = model.session.rest.oauth.login.url;
  const loginAs = false;
  return loginByRest(deps, model, credentials, restUrl, acceptTerms, registrationForm, loginAs, tokens);
}

function loginBack(...args) {
  const [deps, model] = args;
  const restUrl = model.session.rest.oauth.loginBack.url;
  const acceptTerms = true;
  const registrationForm = false;
  const loginAs = true;
  const adminId = null;
  return loginByRest(deps, model, {}, restUrl, acceptTerms, registrationForm, loginAs, adminId);
}

function removeTokens(deps, model) {
  if (
    deps.$sessionStorage &&
    deps.$sessionStorage.userSession &&
    deps.$sessionStorage.userSession.tokens &&
    !_.isEmpty(deps.$sessionStorage.userSession.tokens)
  ) {
    deps.restSrv.remove(CONTEXT, model.session.rest.oauth.logout.url).catch(() => {});
  }
  return Promise.resolve();
}

function logout(deps, model, registrationConfirm) {
  return removeTokens(deps, model)
    .then(() => sessionModule.resetSession(deps, model))
    .then(() => deps.init())
    .then((newModel) => {
      sessionStorage.clear();
      deps.$state.go('home-view', {
        reload: true,
        registrationConfirm,
      });
      return newModel;
    });
}

function resetPassword(deps, model, answerObj) {
  return deps.restSrv.create(FORGOT_PASSOWRD_CONTEXT, model.session.rest.auth.resetPassword.url, answerObj);
}

function remindUsername(deps, model, formModel) {
  const { url } = model.session.rest.auth.remindUsername;
  const { captchaToken, phone } = formModel;
  const queryParams = { phoneNumber: phone };
  const urlParams = { captchaToken };

  return deps.restSrv.create(FORGOT_USERNAME_CONTEXT, url, queryParams, urlParams).catch((e) => {
    throw e;
  });
}

export default {
  initializeModel,
  login,
  loginByRest,
  loginBack,
  logout,
  resetPassword,
  remindUsername,
  changeLocale: sessionModule.changeLocale,
  resetSession: sessionModule.resetSession,
  initializeSession: sessionModule.initializeSession,
  updateSession: sessionModule.updateSession,
  // applyMenu: sessionModule.applyMenu,
  getServerTime,
};



// WEBPACK FOOTER //
// ./src/modules/auth/logic/auth.js